export default __webpack_public_path__ + "static/media/foundation.a2a1be1e.png";